import type { LocaleModule } from '../types';

const zhCN = {
  'common.unknown': '未知',
  'common.close': '关闭',
  'common.cancel': '取消',
  'common.send': '发送',
  'common.on': '开',
  'common.off': '关',
  'common.user': '用户',
  'nav.overview': '设备总览',
  'nav.voiceGroup': '网络中继（用户组）',
  'nav.serialDebug': '串口调试',
  'nav.main': '主导航',
  'nav.gps': 'GPS 坐标',
  'nav.currentDate': '当前日期',
  'userMenu.label': '用户菜单',
  'userMenu.profile': '个人信息',
  'userMenu.switchMobile': '切换到移动端',
  'userMenu.logout': '退出登录',
  'overview.onlineDevices': '在线设备',
  'overview.totalDevices': '共 {count} 台',
  'overview.addDevice': '添加设备',
  'overview.loginRequired': '请先登录以查看设备列表',
  'overview.loading': '正在加载设备…',
  'overview.empty': '暂无会话设备，点击添加',
  'status.online': '在线',
  'status.inUse': '使用中',
  'status.offline': '离线',
  'status.unknown': '未知',
  'card.invalidDeviceId': '无效设备 ID',
  'card.deleteDevice': '删除设备',
  'card.deleteDeviceNamed': '删除设备 {name}',
  'card.frequency': '频率',
  'card.frequencyDown': '频率减 1 kHz',
  'card.frequencyMhz': '频率 MHz',
  'card.frequencyUp': '频率加 1 kHz',
  'card.pttTransmit': 'PTT 发射',
  'card.offlinePreview': '设备离线 · 预览不可用',
  'card.metersOffline': '仪表离线 · 无数据',
  'card.deleteTitle': '确认删除设备',
  'card.delete': '删除',
  'card.deleteConfirm': '确定要从当前会话中删除该设备吗？',
  'card.deviceName': '设备：{name}',
  'card.serialNumber': 'SN：{serial}',
  'gauge.po': 'PO 表',
  'gauge.signal': 'S 表',
  'gauge.range': '0–34 档',
  'detail.confirmFrequency': '确定频率',
  'detail.confirmMode': '确定模式',
  'detail.selectSpectrumDevice': '请选择设备以显示实时频谱与瀑布图',
  'detail.invalidDevice': '无效设备',
  'detail.deviceOffline': '设备离线',
  'detail.loginForData': '未登录，无法拉取数据',
  'detail.amplifierPreviewMissingId': '功放设备缺少 snNumber，无法渲染预览',
  'control.title': '控制面板',
  'control.scrollArea': '电台控制面板滚动区',
  'control.commandSent': '{label} 指令已发送',
  'control.commandFailed': '指令发送失败',
  'control.splitSent': 'SPLIT 指令已发送',
  'control.splitFailed': 'SPLIT 发送失败',
  'control.comingSoon': '功能正在完善',
  'control.selectDeviceFirst': '请先在主界面选择设备',
  'control.loginFirst': '请先登录',
  'control.powerOnSent': '开机指令已发送',
  'control.powerOffSent': '关机指令已发送',
  'control.powerFailed': '电源指令发送失败',
  'control.parameterSent': '参数指令已发送',
  'control.parameterFailed': '参数发送失败',
  'control.toneSent': '亚音指令已发送',
  'control.toneFailed': '亚音发送失败',
  'control.toneTitle': 'TONE · 亚音',
  'control.txPowerHiLoTitle': 'L/H · 高低功率',
  'control.factoryTitle': 'FACT · 工程参数',
  'control.factoryHint': '校准',
  'control.channelTitle': 'CHAN · 信道调试',
  'control.channelHint': '信道',
  'control.filterBpf': '带通',
  'control.filterLpf': '低通',
  'control.filterWidth': '带宽',
  'control.factoryPasswordTitle': '工程参数验证',
  'control.factoryPasswordHint': '请输入工程参数密码后进入校准页。',
  'control.factoryPasswordWrong': '工程参数密码错误',
  'control.factoryTabBand': '波段校准',
  'control.factoryTabGlobal': '全局参数',
  'control.factoryTabMode': '工程模式',
  'control.factoryRead': '读',
  'control.factoryWrite': '写',
  'control.factoryReadBand': '读取本波段',
  'control.factoryReadAll': '读取全部',
  'control.factoryReadGlobal': '读取全局参数',
  'control.factoryModeOff': '关闭',
  'control.factoryModeOn': '打开',
  'control.factoryModeSend': '下发',
  'control.factoryModeHint': '写入校准值前建议先打开工程模式。',
  'control.factoryLastCommand': '最近',
  'control.factoryReadCurrent': '一键读取',
  'control.factoryEngineering': '工程模式',
  'control.factoryBand': '波段',
  'control.factoryMode': '模式',
  'control.factoryPower': '功率',
  'control.factoryUnread': '未读取',
  'control.factoryReadTimeout': '读取超时',
  'control.factoryWriteFailed': '写入失败',
  'control.txPowerTitle': 'PWR · 发射功率',
  'control.txPowerLow': '低功率',
  'control.txPowerHigh': '高功率',
  'control.txPowerLevel': '功率等级',
  'control.txPowerHighShort': '高',
  'control.txPowerLowShort': '低',
  'control.txCtcss': '发射亚音索引 (0–51)',
  'control.rxCtcss': '接收亚音索引 (0–51)',
  'control.leadTone': '前导音 (0 / 1750 / 2135)',
  'control.devicePower': '设备电源',
  'control.powerPrompt': '请选择要发送给设备的电源指令。',
  'control.sendPowerOn': '发送开机指令',
  'control.sendPowerOff': '发送关机指令',
  'control.hint.power': '电源',
  'control.hint.rfg': '射频增益',
  'control.hint.ifg': '中频增益',
  'control.hint.sql': '静噪',
  'control.hint.agc': '自动增益',
  'control.hint.amp': '前级放大',
  'control.hint.svol': '扬声器',
  'control.hint.hvol': '耳机',
  'control.hint.mic': '麦克风',
  'control.hint.cmp': '语音压扩',
  'control.hint.bas': '低音 EQ',
  'control.hint.trb': '高音 EQ',
  'control.hint.split': '异频',
  'control.hint.ab': '频率切换',
  'control.hint.nb': '噪声抑制',
  'control.hint.nr': '降噪',
  'control.hint.band': '波段',
  'control.hint.nrl': '降噪等级',
  'control.hint.nbl': '抑噪等级',
  'control.hint.peak': '峰值',
  'control.hint.atu': '自动调谐',
  'control.hint.span': '频谱范围',
  'control.hint.ref': '参考电平',
  'control.hint.lohi': '高低功率',
  'control.hint.pwr': '发射功率',
  'control.hint.fact': '工程参数',
  'control.hint.chan': '信道调试',
  'control.hint.tone': '亚音',
  'control.hint.speed': '键速',
  'control.hint.disp': '显示',
  'control.hint.rit': '接收微调',
  'control.hint.xit': '发射微调',
  'control.hint.ltime': '长按时间',
  'control.hint.hplv': '耳机电平',
  'control.hint.train': '训练',
  'control.hint.keys': '按键模式',
  'control.hint.cwdec': 'CW 解码',
  'control.hint.cwth': '解码阈值',
  'control.hint.fmt': '音频格式',
  'control.enum.frequencyA': 'A 频',
  'control.enum.frequencyB': 'B 频',
  'control.enum.tuningStart': '开始调谐',
  'control.enum.spectrumWaterfall': '频谱 + 瀑布图',
  'control.enum.spectrumOnly': '仅频谱',
  'control.enum.waterfallOnly': '仅瀑布图',
  'control.enum.dataAudio': '音频',
  'control.enum.dataIq': 'IQ',
  'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': '功能开发中',
  'message.afFailed': 'AF 参数发送失败',
  'message.rfFailed': 'RF 参数发送失败',
  'message.loginToChangeFrequency': '请先登录后再修改频率',
  'message.frequencyFailed': '频率设置失败',
  'message.frequencyError': '频率设置异常',
  'message.loginToChangeMode': '请先登录后再修改模式',
  'message.modeFailed': '模式设置失败',
  'message.modeError': '模式设置异常',
  'message.loginToModify': '请先登录后再修改',
  'message.invalidFrequency': '请输入有效的频率值',
  'message.invalidDeviceId': '设备 ID 无效',
  'message.deviceNotInSession': '会话中未找到该设备',
  'message.devicePageOpenFailed': '无法打开设备页（缺少类型或序列号）',
  'message.removeFailed': '从会话移除失败',
  'message.removed': '已从会话中移除',
  'message.removeRetry': '移除失败，请稍后重试',
  'modal.power': '电源',
  'modal.meter': '电表',
  'modal.switchMeter': '切换表（SWR/AUD/ALC）',
  'modal.powerOn': '开机',
  'modal.powerOff': '关机',
  'modal.sendPowerOnMqtt': '发送 PMR171 开机指令（MQTT）',
  'modal.sendPowerOffMqtt': '发送 PMR171 关机指令（MQTT）',
  'modal.afMenu': 'AF 菜单',
  'modal.volume': '音量',
  'modal.sliderHelp': '拖动调整数值，松手后通过 MQTT 下发。',
  'modal.loginForAf': '请先登录后再调节 AF。',
  'modal.selectForAf': '请先在主界面选择设备后再调节 AF。',
  'modal.more': '更多',
  'modal.afMore': '后续 AF 子项将放在此页',
  'modal.rfMenu': 'RF 菜单',
  'modal.radioFrequency': '射频',
  'modal.loginForRf': '请先登录后再调节 RF。',
  'modal.selectForRf': '请先在主界面选择设备后再调节 RF。',
  'modal.rfMore': '后续 RF 子项将放在此页',
  'slider.speaker': '扬声器音量',
  'slider.headphone': '耳机音量',
  'slider.mic': 'MIC 增益',
  'slider.compander': '语音压扩比',
  'slider.bass': '低音 EQ',
  'slider.treble': '高音 EQ',
  'slider.rfGain': '射频增益（RFG）',
  'slider.ifGain': '中频增益',
  'slider.squelch': '静噪（SQL）',
  'slider.agc': 'AGC',
  'slider.preamp': '前级放大器（0=AMPA，1=AMPB）',
  'mode.usb': '上边带',
  'mode.lsb': '下边带',
  'mode.cwr': '连续波接收',
  'mode.cwl': '连续波发射',
  'mode.am': '调幅',
  'mode.wfm': '宽带调频',
  'mode.nfm': '窄带调频',
  'mode.digi': '数字模式',
  'mode.pkt': '数据包模式',
  'button.power': '电源',
  'button.morePending': '更多（待定）',
} as const;

export type RadioRemoteMessages = { [Key in keyof typeof zhCN]: string };

const zhHK: RadioRemoteMessages = {
  ...zhCN,
  'common.unknown': '未知',
  'common.close': '關閉',
  'common.cancel': '取消',
  'common.send': '傳送',
  'common.on': '開',
  'common.off': '關',
  'common.user': '用戶',
  'nav.overview': '裝置總覽',
  'nav.voiceGroup': '網絡中繼（用戶群組）',
  'nav.serialDebug': '串口除錯',
  'nav.main': '主導覽',
  'nav.gps': 'GPS 座標',
  'nav.currentDate': '目前日期',
  'userMenu.label': '用戶選單',
  'userMenu.profile': '個人資料',
  'userMenu.switchMobile': '切換至流動版',
  'userMenu.logout': '登出',
  'overview.onlineDevices': '在線裝置',
  'overview.totalDevices': '共 {count} 台',
  'overview.addDevice': '新增裝置',
  'overview.loginRequired': '請先登入以查看裝置清單',
  'overview.loading': '正在載入裝置…',
  'overview.empty': '暫無工作階段裝置，按此新增',
  'status.online': '在線',
  'status.inUse': '使用中',
  'status.offline': '離線',
  'card.invalidDeviceId': '無效裝置 ID',
  'card.deleteDevice': '刪除裝置',
  'card.deleteDeviceNamed': '刪除裝置 {name}',
  'card.frequency': '頻率',
  'card.frequencyDown': '頻率降低 1 kHz',
  'card.frequencyMhz': '頻率 MHz',
  'card.frequencyUp': '頻率提高 1 kHz',
  'card.pttTransmit': 'PTT 發射',
  'card.offlinePreview': '裝置離線 · 無法預覽',
  'card.metersOffline': '儀表離線 · 無數據',
  'card.deleteTitle': '確認刪除裝置',
  'card.delete': '刪除',
  'card.deleteConfirm': '確定要從目前工作階段刪除此裝置嗎？',
  'card.deviceName': '裝置：{name}',
  'card.serialNumber': 'SN：{serial}',
  'gauge.po': 'PO 儀表',
  'gauge.signal': 'S 儀表',
  'gauge.range': '0–34 級',
  'detail.confirmFrequency': '確認頻率',
  'detail.confirmMode': '確認模式',
  'detail.selectSpectrumDevice': '請選擇裝置以顯示即時頻譜及瀑布圖',
  'detail.invalidDevice': '無效裝置',
  'detail.deviceOffline': '裝置離線',
  'detail.loginForData': '尚未登入，無法擷取數據',
  'detail.amplifierPreviewMissingId': '功放裝置缺少 snNumber，無法顯示預覽',
  'control.title': '控制面板',
  'control.scrollArea': '電台控制面板捲動區',
  'control.commandSent': '{label} 指令已傳送',
  'control.commandFailed': '指令傳送失敗',
  'control.splitSent': 'SPLIT 指令已傳送',
  'control.splitFailed': 'SPLIT 傳送失敗',
  'control.comingSoon': '功能正在完善',
  'control.selectDeviceFirst': '請先在主畫面選擇裝置',
  'control.loginFirst': '請先登入',
  'control.powerOnSent': '開機指令已傳送',
  'control.powerOffSent': '關機指令已傳送',
  'control.powerFailed': '電源指令傳送失敗',
  'control.parameterSent': '參數指令已傳送',
  'control.parameterFailed': '參數傳送失敗',
  'control.toneSent': '亞音指令已傳送',
  'control.toneFailed': '亞音傳送失敗',
  'control.toneTitle': 'TONE · 亞音',
  'control.txPowerHiLoTitle': 'L/H · 高低功率',
  'control.factoryTitle': 'FACT · 工程參數',
  'control.factoryHint': '校準',
  'control.channelTitle': 'CHAN · 信道除錯',
  'control.channelHint': '信道',
  'control.filterBpf': '帶通',
  'control.filterLpf': '低通',
  'control.filterWidth': '頻寬',
  'control.factoryPasswordTitle': '工程參數驗證',
  'control.factoryPasswordHint': '請輸入工程參數密碼後進入校準頁。',
  'control.factoryPasswordWrong': '工程參數密碼錯誤',
  'control.factoryTabBand': '波段校準',
  'control.factoryTabGlobal': '全域參數',
  'control.factoryTabMode': '工程模式',
  'control.factoryRead': '讀',
  'control.factoryWrite': '寫',
  'control.factoryReadBand': '讀取本波段',
  'control.factoryReadAll': '讀取全部',
  'control.factoryReadGlobal': '讀取全域參數',
  'control.factoryModeOff': '關閉',
  'control.factoryModeOn': '開啟',
  'control.factoryModeSend': '下發',
  'control.factoryModeHint': '寫入校準值前建議先開啟工程模式。',
  'control.factoryLastCommand': '最近',
  'control.factoryReadCurrent': '一鍵讀取',
  'control.factoryEngineering': '工程模式',
  'control.factoryBand': '波段',
  'control.factoryMode': '模式',
  'control.factoryPower': '功率',
  'control.factoryUnread': '未讀取',
  'control.factoryReadTimeout': '讀取逾時',
  'control.factoryWriteFailed': '寫入失敗',
  'control.txPowerTitle': 'PWR · 發射功率',
  'control.txPowerLow': '低功率',
  'control.txPowerHigh': '高功率',
  'control.txPowerLevel': '功率等級',
  'control.txPowerHighShort': '高',
  'control.txPowerLowShort': '低',
  'control.txCtcss': '發射亞音索引 (0–51)',
  'control.rxCtcss': '接收亞音索引 (0–51)',
  'control.leadTone': '前導音 (0 / 1750 / 2135)',
  'control.devicePower': '裝置電源',
  'control.powerPrompt': '請選擇要傳送至裝置的電源指令。',
  'control.sendPowerOn': '傳送開機指令',
  'control.sendPowerOff': '傳送關機指令',
  'control.hint.power': '電源', 'control.hint.rfg': '射頻增益', 'control.hint.ifg': '中頻增益',
  'control.hint.sql': '靜噪', 'control.hint.agc': '自動增益', 'control.hint.amp': '前級放大',
  'control.hint.svol': '揚聲器', 'control.hint.hvol': '耳機', 'control.hint.mic': '咪高峰',
  'control.hint.cmp': '語音壓擴', 'control.hint.bas': '低音 EQ', 'control.hint.trb': '高音 EQ',
  'control.hint.split': '異頻', 'control.hint.ab': '頻率切換', 'control.hint.nb': '噪聲抑制',
  'control.hint.nr': '降噪', 'control.hint.band': '波段', 'control.hint.nrl': '降噪等級',
  'control.hint.nbl': '抑噪等級', 'control.hint.peak': '峰值', 'control.hint.atu': '自動調諧',
  'control.hint.span': '頻譜範圍', 'control.hint.ref': '參考電平', 'control.hint.lohi': '高低功率', 'control.hint.pwr': '發射功率', 'control.hint.fact': '工程參數',
  'control.hint.chan': '信道除錯',
  'control.hint.tone': '亞音', 'control.hint.speed': '鍵速', 'control.hint.disp': '顯示',
  'control.hint.rit': '接收微調', 'control.hint.xit': '發射微調', 'control.hint.ltime': '長按時間',
  'control.hint.hplv': '耳機電平', 'control.hint.train': '訓練', 'control.hint.keys': '按鍵模式',
  'control.hint.cwdec': 'CW 解碼', 'control.hint.cwth': '解碼閾值', 'control.hint.fmt': '音訊格式',
  'control.enum.frequencyA': 'A 頻',
  'control.enum.frequencyB': 'B 頻',
  'control.enum.tuningStart': '開始調諧',
  'control.enum.spectrumWaterfall': '頻譜 + 瀑布圖',
  'control.enum.spectrumOnly': '僅頻譜',
  'control.enum.waterfallOnly': '僅瀑布圖',
  'control.enum.dataAudio': '音訊',
  'control.enum.dataIq': 'IQ',
  'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': '功能開發中',
  'message.afFailed': 'AF 參數傳送失敗',
  'message.rfFailed': 'RF 參數傳送失敗',
  'message.loginToChangeFrequency': '請先登入再修改頻率',
  'message.frequencyFailed': '頻率設定失敗',
  'message.frequencyError': '頻率設定異常',
  'message.loginToChangeMode': '請先登入再修改模式',
  'message.modeFailed': '模式設定失敗',
  'message.modeError': '模式設定異常',
  'message.loginToModify': '請先登入再修改',
  'message.invalidFrequency': '請輸入有效的頻率值',
  'message.invalidDeviceId': '裝置 ID 無效',
  'message.deviceNotInSession': '工作階段中找不到該裝置',
  'message.devicePageOpenFailed': '無法開啟裝置頁（缺少類型或序號）',
  'message.removeFailed': '從工作階段移除失敗',
  'message.removed': '已從工作階段移除',
  'message.removeRetry': '移除失敗，請稍後再試',
  'modal.power': '電源',
  'modal.meter': '儀表',
  'modal.switchMeter': '切換儀表（SWR/AUD/ALC）',
  'modal.powerOn': '開機',
  'modal.powerOff': '關機',
  'modal.sendPowerOnMqtt': '傳送 PMR171 開機指令（MQTT）',
  'modal.sendPowerOffMqtt': '傳送 PMR171 關機指令（MQTT）',
  'modal.afMenu': 'AF 選單',
  'modal.volume': '音量',
  'modal.sliderHelp': '拖動以調整數值，放開後透過 MQTT 傳送。',
  'modal.loginForAf': '請先登入再調整 AF。',
  'modal.selectForAf': '請先在主畫面選擇裝置再調整 AF。',
  'modal.more': '更多',
  'modal.afMore': '後續 AF 項目將置於此頁',
  'modal.rfMenu': 'RF 選單',
  'modal.radioFrequency': '射頻',
  'modal.loginForRf': '請先登入再調整 RF。',
  'modal.selectForRf': '請先在主畫面選擇裝置再調整 RF。',
  'modal.rfMore': '後續 RF 項目將置於此頁',
  'slider.speaker': '揚聲器音量',
  'slider.headphone': '耳機音量',
  'slider.mic': 'MIC 增益',
  'slider.compander': '語音壓擴比',
  'slider.bass': '低音 EQ',
  'slider.treble': '高音 EQ',
  'slider.rfGain': '射頻增益（RFG）',
  'slider.ifGain': '中頻增益',
  'slider.squelch': '靜噪（SQL）',
  'slider.preamp': '前級放大器（0=AMPA，1=AMPB）',
  'mode.usb': '上邊帶',
  'mode.lsb': '下邊帶',
  'mode.cwr': '連續波接收',
  'mode.cwl': '連續波發射',
  'mode.am': '調幅',
  'mode.wfm': '寬帶調頻',
  'mode.nfm': '窄帶調頻',
  'mode.digi': '數碼模式',
  'mode.pkt': '數據包模式',
  'button.power': '電源',
  'button.morePending': '更多（待定）',
};

const enUS: RadioRemoteMessages = {
  ...zhCN,
  'common.unknown': 'Unknown', 'common.close': 'Close', 'common.cancel': 'Cancel', 'common.send': 'Send',
  'common.on': 'On', 'common.off': 'Off', 'common.user': 'User',
  'nav.overview': 'Device Overview', 'nav.voiceGroup': 'Network Relay (Voice Group)', 'nav.serialDebug': 'Serial debug', 'nav.main': 'Main navigation',
  'nav.gps': 'GPS Coordinates', 'nav.currentDate': 'Current Date',
  'userMenu.label': 'User menu', 'userMenu.profile': 'Profile', 'userMenu.switchMobile': 'Switch to mobile', 'userMenu.logout': 'Log out',
  'overview.onlineDevices': 'Online Devices', 'overview.totalDevices': '{count} total', 'overview.addDevice': 'Add Device',
  'overview.loginRequired': 'Log in to view your devices', 'overview.loading': 'Loading devices…',
  'overview.empty': 'No devices in this session. Click to add one.',
  'status.online': 'Online', 'status.inUse': 'In use', 'status.offline': 'Offline', 'status.unknown': 'Unknown',
  'card.invalidDeviceId': 'Invalid device ID', 'card.deleteDevice': 'Delete device',
  'card.deleteDeviceNamed': 'Delete device {name}', 'card.frequency': 'Frequency',
  'card.frequencyDown': 'Decrease frequency by 1 kHz', 'card.frequencyMhz': 'Frequency in MHz',
  'card.frequencyUp': 'Increase frequency by 1 kHz', 'card.pttTransmit': 'PTT transmit',
  'card.offlinePreview': 'Device offline · Preview unavailable', 'card.metersOffline': 'Meters offline · No data',
  'card.deleteTitle': 'Delete Device', 'card.delete': 'Delete',
  'card.deleteConfirm': 'Remove this device from the current session?',
  'card.deviceName': 'Device: {name}', 'card.serialNumber': 'SN: {serial}',
  'gauge.po': 'PO Meter', 'gauge.signal': 'S Meter', 'gauge.range': '0–34 steps',
  'detail.confirmFrequency': 'Confirm Frequency', 'detail.confirmMode': 'Confirm Mode',
  'detail.selectSpectrumDevice': 'Select a device to view its live spectrum and waterfall',
  'detail.invalidDevice': 'Invalid device', 'detail.deviceOffline': 'Device offline',
  'detail.loginForData': 'Log in to retrieve data',
  'detail.amplifierPreviewMissingId': 'Amplifier is missing snNumber; preview cannot be rendered',
  'control.title': 'Control Panel', 'control.scrollArea': 'Radio control panel scroll area',
  'control.commandSent': '{label} command sent', 'control.commandFailed': 'Failed to send command',
  'control.splitSent': 'SPLIT command sent', 'control.splitFailed': 'Failed to send SPLIT command',
  'control.comingSoon': 'This feature is being completed', 'control.selectDeviceFirst': 'Select a device on the overview first',
  'control.loginFirst': 'Log in first', 'control.powerOnSent': 'Power-on command sent',
  'control.powerOffSent': 'Power-off command sent', 'control.powerFailed': 'Failed to send power command',
  'control.parameterSent': 'Parameter command sent', 'control.parameterFailed': 'Failed to send parameter',
  'control.toneSent': 'Tone command sent', 'control.toneFailed': 'Failed to send tone command',
  'control.toneTitle': 'TONE · Subtone',
  'control.txPowerHiLoTitle': 'L/H · High / low',
  'control.factoryTitle': 'FACT · Factory params',
  'control.factoryHint': 'Calibrate',
  'control.channelTitle': 'CHAN · Channel debug',
  'control.channelHint': 'Channel',
  'control.filterBpf': 'Band-pass',
  'control.filterLpf': 'Low-pass',
  'control.filterWidth': 'Width',
  'control.factoryPasswordTitle': 'Factory password',
  'control.factoryPasswordHint': 'Enter the factory password to open calibration.',
  'control.factoryPasswordWrong': 'Wrong factory password',
  'control.factoryTabBand': 'Band calibration',
  'control.factoryTabGlobal': 'Global params',
  'control.factoryTabMode': 'Factory mode',
  'control.factoryRead': 'Read',
  'control.factoryWrite': 'Write',
  'control.factoryReadBand': 'Read this band',
  'control.factoryReadAll': 'Read all',
  'control.factoryReadGlobal': 'Read global params',
  'control.factoryModeOff': 'Off',
  'control.factoryModeOn': 'On',
  'control.factoryModeSend': 'Send',
  'control.factoryModeHint': 'Turn on factory mode before writing calibration values.',
  'control.factoryLastCommand': 'Last',
  'control.factoryReadCurrent': 'Read all',
  'control.factoryEngineering': 'Factory mode',
  'control.factoryBand': 'Band',
  'control.factoryMode': 'Mode',
  'control.factoryPower': 'Power',
  'control.factoryUnread': 'Unread',
  'control.factoryReadTimeout': 'Read timed out',
  'control.factoryWriteFailed': 'Write failed',
  'control.txPowerTitle': 'PWR · TX power',
  'control.txPowerLow': 'Low power',
  'control.txPowerHigh': 'High power',
  'control.txPowerLevel': 'Power level',
  'control.txPowerHighShort': 'H',
  'control.txPowerLowShort': 'L',
  'control.txCtcss': 'Transmit subtone index (0–51)',
  'control.rxCtcss': 'Receive subtone index (0–51)', 'control.leadTone': 'Lead tone (0 / 1750 / 2135)',
  'control.devicePower': 'Device Power', 'control.powerPrompt': 'Choose a power command to send to the device.',
  'control.sendPowerOn': 'Send Power-on Command', 'control.sendPowerOff': 'Send Power-off Command',
  'control.hint.power': 'Power', 'control.hint.rfg': 'RF gain', 'control.hint.ifg': 'IF gain',
  'control.hint.sql': 'Squelch', 'control.hint.agc': 'Automatic gain', 'control.hint.amp': 'Preamplifier',
  'control.hint.svol': 'Speaker', 'control.hint.hvol': 'Headphones', 'control.hint.mic': 'Microphone',
  'control.hint.cmp': 'Speech compander', 'control.hint.bas': 'Bass EQ', 'control.hint.trb': 'Treble EQ',
  'control.hint.split': 'Split frequency', 'control.hint.ab': 'Switch frequency', 'control.hint.nb': 'Noise blanker',
  'control.hint.nr': 'Noise reduction', 'control.hint.band': 'Band', 'control.hint.nrl': 'Noise reduction level',
  'control.hint.nbl': 'Noise blanker level', 'control.hint.peak': 'Peak', 'control.hint.atu': 'Automatic tuning',
  'control.hint.span': 'Spectrum span', 'control.hint.ref': 'Reference level', 'control.hint.lohi': 'High / low power', 'control.hint.pwr': 'Transmit power', 'control.hint.fact': 'Factory params',
  'control.hint.chan': 'Channel debug',
  'control.hint.tone': 'Subtone', 'control.hint.speed': 'Keying speed', 'control.hint.disp': 'Display',
  'control.hint.rit': 'Receive incremental tuning', 'control.hint.xit': 'Transmit incremental tuning',
  'control.hint.ltime': 'Long-press time', 'control.hint.hplv': 'Headphone level', 'control.hint.train': 'Training',
  'control.hint.keys': 'Key mode', 'control.hint.cwdec': 'CW decoding', 'control.hint.cwth': 'Decode threshold',
  'control.hint.fmt': 'Audio format',
  'control.enum.frequencyA': 'Frequency A', 'control.enum.frequencyB': 'Frequency B',
  'control.enum.tuningStart': 'Start Tuning', 'control.enum.spectrumWaterfall': 'Spectrum + Waterfall',
  'control.enum.spectrumOnly': 'Spectrum Only', 'control.enum.waterfallOnly': 'Waterfall Only',
  'control.enum.dataAudio': 'Audio', 'control.enum.dataIq': 'IQ', 'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': 'Feature under development', 'message.afFailed': 'Failed to send AF parameter',
  'message.rfFailed': 'Failed to send RF parameter', 'message.loginToChangeFrequency': 'Log in before changing frequency',
  'message.frequencyFailed': 'Failed to set frequency', 'message.frequencyError': 'Error while setting frequency',
  'message.loginToChangeMode': 'Log in before changing mode', 'message.modeFailed': 'Failed to set mode',
  'message.modeError': 'Error while setting mode', 'message.loginToModify': 'Log in before making changes',
  'message.invalidFrequency': 'Enter a valid frequency', 'message.invalidDeviceId': 'Invalid device ID',
  'message.deviceNotInSession': 'Device not found in this session',
  'message.devicePageOpenFailed': 'Cannot open device page (missing type or serial number)',
  'message.removeFailed': 'Failed to remove device from session', 'message.removed': 'Device removed from session',
  'message.removeRetry': 'Could not remove device. Try again later.',
  'modal.power': 'Power', 'modal.meter': 'Meter', 'modal.switchMeter': 'Switch Meter (SWR/AUD/ALC)',
  'modal.powerOn': 'Power On', 'modal.powerOff': 'Power Off',
  'modal.sendPowerOnMqtt': 'Send PMR171 power-on command (MQTT)',
  'modal.sendPowerOffMqtt': 'Send PMR171 power-off command (MQTT)',
  'modal.afMenu': 'AF Menu', 'modal.volume': 'Volume',
  'modal.sliderHelp': 'Drag to adjust the value. The value is sent over MQTT when released.',
  'modal.loginForAf': 'Log in before adjusting AF.', 'modal.selectForAf': 'Select a device before adjusting AF.',
  'modal.more': 'More', 'modal.afMore': 'Additional AF controls will appear here.',
  'modal.rfMenu': 'RF Menu', 'modal.radioFrequency': 'RF',
  'modal.loginForRf': 'Log in before adjusting RF.', 'modal.selectForRf': 'Select a device before adjusting RF.',
  'modal.rfMore': 'Additional RF controls will appear here.',
  'slider.speaker': 'Speaker Volume', 'slider.headphone': 'Headphone Volume', 'slider.mic': 'MIC Gain',
  'slider.compander': 'Speech Compander Ratio', 'slider.bass': 'Bass EQ', 'slider.treble': 'Treble EQ',
  'slider.rfGain': 'RF Gain (RFG)', 'slider.ifGain': 'IF Gain', 'slider.squelch': 'Squelch (SQL)',
  'slider.agc': 'AGC', 'slider.preamp': 'Preamplifier (0=AMPA, 1=AMPB)',
  'mode.usb': 'Upper sideband', 'mode.lsb': 'Lower sideband', 'mode.cwr': 'CW receive',
  'mode.cwl': 'CW transmit', 'mode.am': 'Amplitude modulation', 'mode.wfm': 'Wideband FM',
  'mode.nfm': 'Narrowband FM', 'mode.digi': 'Digital mode', 'mode.pkt': 'Packet mode',
  'button.power': 'Power', 'button.morePending': 'More (coming soon)',
};

const ruRU: RadioRemoteMessages = {
  ...enUS,
  'common.unknown': 'Неизвестно', 'common.close': 'Закрыть', 'common.cancel': 'Отмена', 'common.send': 'Отправить',
  'common.on': 'Вкл.', 'common.off': 'Выкл.', 'common.user': 'Пользователь',
  'nav.overview': 'Обзор устройств', 'nav.voiceGroup': 'Сетевой ретранслятор (группа)', 'nav.serialDebug': 'Отладка COM', 'nav.main': 'Главная навигация',
  'nav.gps': 'Координаты GPS', 'nav.currentDate': 'Текущая дата',
  'userMenu.label': 'Меню пользователя', 'userMenu.profile': 'Профиль', 'userMenu.switchMobile': 'Мобильная версия', 'userMenu.logout': 'Выйти',
  'overview.onlineDevices': 'Устройства в сети', 'overview.totalDevices': 'Всего: {count}', 'overview.addDevice': 'Добавить устройство',
  'overview.loginRequired': 'Войдите, чтобы просмотреть устройства', 'overview.loading': 'Загрузка устройств…',
  'overview.empty': 'В сеансе нет устройств. Нажмите, чтобы добавить.',
  'status.online': 'В сети', 'status.inUse': 'Используется', 'status.offline': 'Не в сети', 'status.unknown': 'Неизвестно',
  'card.invalidDeviceId': 'Недопустимый ID устройства', 'card.deleteDevice': 'Удалить устройство',
  'card.deleteDeviceNamed': 'Удалить устройство {name}', 'card.frequency': 'Частота',
  'card.frequencyDown': 'Уменьшить частоту на 1 кГц', 'card.frequencyMhz': 'Частота, МГц',
  'card.frequencyUp': 'Увеличить частоту на 1 кГц', 'card.pttTransmit': 'Передача PTT',
  'card.offlinePreview': 'Устройство не в сети · Предпросмотр недоступен',
  'card.metersOffline': 'Индикаторы не в сети · Нет данных', 'card.deleteTitle': 'Удалить устройство',
  'card.delete': 'Удалить', 'card.deleteConfirm': 'Удалить это устройство из текущего сеанса?',
  'card.deviceName': 'Устройство: {name}', 'card.serialNumber': 'SN: {serial}',
  'gauge.po': 'Индикатор PO', 'gauge.signal': 'S-метр', 'gauge.range': '0–34 дел.',
  'detail.confirmFrequency': 'Подтвердить частоту', 'detail.confirmMode': 'Подтвердить режим',
  'detail.selectSpectrumDevice': 'Выберите устройство для просмотра спектра и водопада',
  'detail.invalidDevice': 'Недопустимое устройство', 'detail.deviceOffline': 'Устройство не в сети',
  'detail.loginForData': 'Войдите для получения данных',
  'detail.amplifierPreviewMissingId': 'У усилителя отсутствует snNumber; предпросмотр невозможен',
  'control.title': 'Панель управления', 'control.scrollArea': 'Прокручиваемая область управления радиостанцией',
  'control.commandSent': 'Команда {label} отправлена', 'control.commandFailed': 'Не удалось отправить команду',
  'control.splitSent': 'Команда SPLIT отправлена', 'control.splitFailed': 'Не удалось отправить SPLIT',
  'control.comingSoon': 'Функция дорабатывается', 'control.selectDeviceFirst': 'Сначала выберите устройство в обзоре',
  'control.loginFirst': 'Сначала войдите', 'control.powerOnSent': 'Команда включения отправлена',
  'control.powerOffSent': 'Команда выключения отправлена', 'control.powerFailed': 'Не удалось отправить команду питания',
  'control.parameterSent': 'Команда параметра отправлена', 'control.parameterFailed': 'Не удалось отправить параметр',
  'control.toneSent': 'Команда субтона отправлена', 'control.toneFailed': 'Не удалось отправить субтон',
  'control.toneTitle': 'TONE · Субтон',
  'control.txPowerHiLoTitle': 'L/H · Высокая / низкая',
  'control.factoryTitle': 'FACT · Заводские параметры',
  'control.factoryHint': 'Калибровка',
  'control.channelTitle': 'CHAN · Каналы',
  'control.channelHint': 'Канал',
  'control.filterBpf': 'ПФ',
  'control.filterLpf': 'НЧ',
  'control.filterWidth': 'Ширина',
  'control.factoryPasswordTitle': 'Пароль завода',
  'control.factoryPasswordHint': 'Введите заводской пароль для калибровки.',
  'control.factoryPasswordWrong': 'Неверный пароль',
  'control.factoryTabBand': 'Калибровка диапазона',
  'control.factoryTabGlobal': 'Общие параметры',
  'control.factoryTabMode': 'Заводской режим',
  'control.factoryRead': 'Чтение',
  'control.factoryWrite': 'Запись',
  'control.factoryReadBand': 'Читать диапазон',
  'control.factoryReadAll': 'Читать всё',
  'control.factoryReadGlobal': 'Читать общие',
  'control.factoryModeOff': 'Выкл',
  'control.factoryModeOn': 'Вкл',
  'control.factoryModeSend': 'Отправить',
  'control.factoryModeHint': 'Перед записью включите заводской режим.',
  'control.factoryLastCommand': 'Последняя',
  'control.factoryReadCurrent': 'Читать всё',
  'control.factoryEngineering': 'Заводской режим',
  'control.factoryBand': 'Диапазон',
  'control.factoryMode': 'Режим',
  'control.factoryPower': 'Мощность',
  'control.factoryUnread': 'Не прочитано',
  'control.factoryReadTimeout': 'Таймаут чтения',
  'control.factoryWriteFailed': 'Ошибка записи',
  'control.txPowerTitle': 'PWR · Мощность TX',
  'control.txPowerLow': 'Низкая мощность',
  'control.txPowerHigh': 'Высокая мощность',
  'control.txPowerLevel': 'Уровень мощности',
  'control.txPowerHighShort': 'В',
  'control.txPowerLowShort': 'Н',
  'control.txCtcss': 'Индекс субтона передачи (0–51)',
  'control.rxCtcss': 'Индекс субтона приёма (0–51)', 'control.leadTone': 'Тон вызова (0 / 1750 / 2135)',
  'control.devicePower': 'Питание устройства', 'control.powerPrompt': 'Выберите команду питания для устройства.',
  'control.sendPowerOn': 'Отправить команду включения', 'control.sendPowerOff': 'Отправить команду выключения',
  'control.hint.power': 'Питание', 'control.hint.rfg': 'Усиление RF', 'control.hint.ifg': 'Усиление ПЧ',
  'control.hint.sql': 'Шумоподавитель', 'control.hint.agc': 'Автоусиление', 'control.hint.amp': 'Предусилитель',
  'control.hint.svol': 'Динамик', 'control.hint.hvol': 'Наушники', 'control.hint.mic': 'Микрофон',
  'control.hint.cmp': 'Компандер речи', 'control.hint.bas': 'Низкие частоты EQ', 'control.hint.trb': 'Высокие частоты EQ',
  'control.hint.split': 'Разнос частот', 'control.hint.ab': 'Переключение частоты', 'control.hint.nb': 'Подавление импульсных помех',
  'control.hint.nr': 'Шумоподавление', 'control.hint.band': 'Диапазон', 'control.hint.nrl': 'Уровень шумоподавления',
  'control.hint.nbl': 'Уровень подавления помех', 'control.hint.peak': 'Пик', 'control.hint.atu': 'Автонастройка',
  'control.hint.span': 'Полоса спектра', 'control.hint.ref': 'Опорный уровень', 'control.hint.lohi': 'Высокая / низкая мощность', 'control.hint.pwr': 'Мощность передачи', 'control.hint.fact': 'Заводские параметры',
  'control.hint.chan': 'Отладка каналов',
  'control.hint.tone': 'Субтон', 'control.hint.speed': 'Скорость ключа', 'control.hint.disp': 'Дисплей',
  'control.hint.rit': 'Подстройка приёма', 'control.hint.xit': 'Подстройка передачи', 'control.hint.ltime': 'Время удержания',
  'control.hint.hplv': 'Уровень наушников', 'control.hint.train': 'Тренировка', 'control.hint.keys': 'Режим ключа',
  'control.hint.cwdec': 'Декодирование CW', 'control.hint.cwth': 'Порог декодирования',
  'control.hint.fmt': 'Формат аудио',
  'control.enum.frequencyA': 'Частота A', 'control.enum.frequencyB': 'Частота B',
  'control.enum.tuningStart': 'Начать настройку', 'control.enum.spectrumWaterfall': 'Спектр + водопад',
  'control.enum.spectrumOnly': 'Только спектр', 'control.enum.waterfallOnly': 'Только водопад',
  'control.enum.dataAudio': 'Аудио', 'control.enum.dataIq': 'IQ', 'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': 'Функция в разработке', 'message.afFailed': 'Не удалось отправить параметр AF',
  'message.rfFailed': 'Не удалось отправить параметр RF', 'message.loginToChangeFrequency': 'Войдите перед изменением частоты',
  'message.frequencyFailed': 'Не удалось задать частоту', 'message.frequencyError': 'Ошибка задания частоты',
  'message.loginToChangeMode': 'Войдите перед изменением режима', 'message.modeFailed': 'Не удалось задать режим',
  'message.modeError': 'Ошибка задания режима', 'message.loginToModify': 'Войдите перед изменением',
  'message.invalidFrequency': 'Введите допустимую частоту', 'message.invalidDeviceId': 'Недопустимый ID устройства',
  'message.removeFailed': 'Не удалось удалить устройство из сеанса', 'message.removed': 'Устройство удалено из сеанса',
  'message.removeRetry': 'Не удалось удалить устройство. Повторите позже.',
  'modal.power': 'Питание', 'modal.meter': 'Индикатор', 'modal.switchMeter': 'Переключить индикатор (SWR/AUD/ALC)',
  'modal.powerOn': 'Включить', 'modal.powerOff': 'Выключить', 'modal.afMenu': 'Меню AF', 'modal.volume': 'Громкость',
  'modal.sendPowerOnMqtt': 'Отправить команду включения PMR171 (MQTT)',
  'modal.sendPowerOffMqtt': 'Отправить команду выключения PMR171 (MQTT)',
  'modal.sliderHelp': 'Перетащите ползунок; значение отправится по MQTT после отпускания.',
  'modal.loginForAf': 'Войдите для настройки AF.', 'modal.selectForAf': 'Выберите устройство для настройки AF.',
  'modal.more': 'Ещё', 'modal.afMore': 'Дополнительные параметры AF появятся здесь.',
  'modal.rfMenu': 'Меню RF', 'modal.radioFrequency': 'РЧ',
  'modal.loginForRf': 'Войдите для настройки RF.', 'modal.selectForRf': 'Выберите устройство для настройки RF.',
  'modal.rfMore': 'Дополнительные параметры RF появятся здесь.',
  'slider.speaker': 'Громкость динамика', 'slider.headphone': 'Громкость наушников', 'slider.mic': 'Усиление MIC',
  'slider.compander': 'Коэффициент компандера', 'slider.bass': 'Низкие частоты EQ', 'slider.treble': 'Высокие частоты EQ',
  'slider.rfGain': 'Усиление RF (RFG)', 'slider.ifGain': 'Усиление ПЧ', 'slider.squelch': 'Шумоподавитель (SQL)',
  'slider.preamp': 'Предусилитель (0=AMPA, 1=AMPB)',
  'mode.usb': 'Верхняя боковая полоса', 'mode.lsb': 'Нижняя боковая полоса', 'mode.cwr': 'Приём CW',
  'mode.cwl': 'Передача CW', 'mode.am': 'Амплитудная модуляция', 'mode.wfm': 'Широкополосная ЧМ',
  'mode.nfm': 'Узкополосная ЧМ', 'mode.digi': 'Цифровой режим', 'mode.pkt': 'Пакетный режим',
  'button.power': 'Питание', 'button.morePending': 'Ещё (скоро)',
};

const esES: RadioRemoteMessages = {
  ...enUS,
  'common.unknown': 'Desconocido', 'common.close': 'Cerrar', 'common.cancel': 'Cancelar', 'common.send': 'Enviar',
  'common.on': 'Activado', 'common.off': 'Desactivado', 'common.user': 'Usuario',
  'nav.overview': 'Vista general de dispositivos', 'nav.voiceGroup': 'Repetidor de red (grupo)', 'nav.serialDebug': 'Depuración serie', 'nav.main': 'Navegación principal',
  'nav.gps': 'Coordenadas GPS', 'nav.currentDate': 'Fecha actual',
  'userMenu.label': 'Menú de usuario', 'userMenu.profile': 'Perfil', 'userMenu.switchMobile': 'Cambiar a móvil', 'userMenu.logout': 'Cerrar sesión',
  'overview.onlineDevices': 'Dispositivos en línea', 'overview.totalDevices': '{count} en total', 'overview.addDevice': 'Añadir dispositivo',
  'overview.loginRequired': 'Inicia sesión para ver tus dispositivos', 'overview.loading': 'Cargando dispositivos…',
  'overview.empty': 'No hay dispositivos en esta sesión. Haz clic para añadir uno.',
  'status.online': 'En línea', 'status.inUse': 'En uso', 'status.offline': 'Sin conexión', 'status.unknown': 'Desconocido',
  'card.invalidDeviceId': 'ID de dispositivo no válido', 'card.deleteDevice': 'Eliminar dispositivo',
  'card.deleteDeviceNamed': 'Eliminar dispositivo {name}', 'card.frequency': 'Frecuencia',
  'card.frequencyDown': 'Reducir la frecuencia 1 kHz', 'card.frequencyMhz': 'Frecuencia en MHz',
  'card.frequencyUp': 'Aumentar la frecuencia 1 kHz', 'card.pttTransmit': 'Transmitir por PTT',
  'card.offlinePreview': 'Dispositivo sin conexión · Vista previa no disponible',
  'card.metersOffline': 'Medidores sin conexión · Sin datos', 'card.deleteTitle': 'Eliminar dispositivo',
  'card.delete': 'Eliminar', 'card.deleteConfirm': '¿Quitar este dispositivo de la sesión actual?',
  'card.deviceName': 'Dispositivo: {name}', 'card.serialNumber': 'NS: {serial}',
  'gauge.po': 'Medidor PO', 'gauge.signal': 'Medidor S', 'gauge.range': '0–34 pasos',
  'detail.confirmFrequency': 'Confirmar frecuencia', 'detail.confirmMode': 'Confirmar modo',
  'detail.selectSpectrumDevice': 'Selecciona un dispositivo para ver el espectro y la cascada en tiempo real',
  'detail.invalidDevice': 'Dispositivo no válido', 'detail.deviceOffline': 'Dispositivo sin conexión',
  'detail.loginForData': 'Inicia sesión para obtener datos',
  'detail.amplifierPreviewMissingId': 'Falta snNumber en el amplificador; no se puede mostrar la vista previa',
  'control.title': 'Panel de control', 'control.scrollArea': 'Área desplazable del panel de radio',
  'control.commandSent': 'Comando {label} enviado', 'control.commandFailed': 'No se pudo enviar el comando',
  'control.splitSent': 'Comando SPLIT enviado', 'control.splitFailed': 'No se pudo enviar SPLIT',
  'control.comingSoon': 'Esta función se está completando', 'control.selectDeviceFirst': 'Selecciona primero un dispositivo',
  'control.loginFirst': 'Inicia sesión primero', 'control.powerOnSent': 'Comando de encendido enviado',
  'control.powerOffSent': 'Comando de apagado enviado', 'control.powerFailed': 'No se pudo enviar el comando de alimentación',
  'control.parameterSent': 'Comando de parámetro enviado', 'control.parameterFailed': 'No se pudo enviar el parámetro',
  'control.toneSent': 'Comando de subtono enviado', 'control.toneFailed': 'No se pudo enviar el subtono',
  'control.toneTitle': 'TONE · Subtono',
  'control.txPowerHiLoTitle': 'L/H · Alta / baja',
  'control.factoryTitle': 'FACT · Parámetros de fábrica',
  'control.factoryHint': 'Calibrar',
  'control.channelTitle': 'CHAN · Canales',
  'control.channelHint': 'Canal',
  'control.filterBpf': 'Pasa banda',
  'control.filterLpf': 'Pasa bajos',
  'control.filterWidth': 'Ancho',
  'control.factoryPasswordTitle': 'Contraseña de fábrica',
  'control.factoryPasswordHint': 'Introduce la contraseña de fábrica.',
  'control.factoryPasswordWrong': 'Contraseña incorrecta',
  'control.factoryTabBand': 'Calibración de banda',
  'control.factoryTabGlobal': 'Parámetros globales',
  'control.factoryTabMode': 'Modo de fábrica',
  'control.factoryRead': 'Leer',
  'control.factoryWrite': 'Escribir',
  'control.factoryReadBand': 'Leer esta banda',
  'control.factoryReadAll': 'Leer todo',
  'control.factoryReadGlobal': 'Leer globales',
  'control.factoryModeOff': 'Apagado',
  'control.factoryModeOn': 'Encendido',
  'control.factoryModeSend': 'Enviar',
  'control.factoryModeHint': 'Activa el modo de fábrica antes de escribir.',
  'control.factoryLastCommand': 'Último',
  'control.factoryReadCurrent': 'Leer todo',
  'control.factoryEngineering': 'Modo de fábrica',
  'control.factoryBand': 'Banda',
  'control.factoryMode': 'Modo',
  'control.factoryPower': 'Potencia',
  'control.factoryUnread': 'Sin leer',
  'control.factoryReadTimeout': 'Tiempo de lectura agotado',
  'control.factoryWriteFailed': 'Error de escritura',
  'control.txPowerTitle': 'PWR · Potencia TX',
  'control.txPowerLow': 'Potencia baja',
  'control.txPowerHigh': 'Potencia alta',
  'control.txPowerLevel': 'Nivel de potencia',
  'control.txPowerHighShort': 'A',
  'control.txPowerLowShort': 'B',
  'control.txCtcss': 'Índice de subtono de transmisión (0–51)',
  'control.rxCtcss': 'Índice de subtono de recepción (0–51)', 'control.leadTone': 'Tono inicial (0 / 1750 / 2135)',
  'control.devicePower': 'Alimentación del dispositivo', 'control.powerPrompt': 'Elige el comando de alimentación que deseas enviar.',
  'control.sendPowerOn': 'Enviar comando de encendido', 'control.sendPowerOff': 'Enviar comando de apagado',
  'control.hint.power': 'Alimentación', 'control.hint.rfg': 'Ganancia RF', 'control.hint.ifg': 'Ganancia IF',
  'control.hint.sql': 'Silenciador', 'control.hint.agc': 'Ganancia automática', 'control.hint.amp': 'Preamplificador',
  'control.hint.svol': 'Altavoz', 'control.hint.hvol': 'Auriculares', 'control.hint.mic': 'Micrófono',
  'control.hint.cmp': 'Compansor de voz', 'control.hint.bas': 'EQ de graves', 'control.hint.trb': 'EQ de agudos',
  'control.hint.split': 'Frecuencia dividida', 'control.hint.ab': 'Cambiar frecuencia', 'control.hint.nb': 'Supresor de impulsos',
  'control.hint.nr': 'Reducción de ruido', 'control.hint.band': 'Banda', 'control.hint.nrl': 'Nivel de reducción de ruido',
  'control.hint.nbl': 'Nivel del supresor', 'control.hint.peak': 'Pico', 'control.hint.atu': 'Sintonización automática',
  'control.hint.span': 'Ancho del espectro', 'control.hint.ref': 'Nivel de referencia', 'control.hint.lohi': 'Potencia alta / baja', 'control.hint.pwr': 'Potencia de transmisión', 'control.hint.fact': 'Parámetros de fábrica',
  'control.hint.chan': 'Depuración de canales',
  'control.hint.tone': 'Subtono', 'control.hint.speed': 'Velocidad de manipulación', 'control.hint.disp': 'Pantalla',
  'control.hint.rit': 'Ajuste fino de recepción', 'control.hint.xit': 'Ajuste fino de transmisión',
  'control.hint.ltime': 'Tiempo de pulsación larga', 'control.hint.hplv': 'Nivel de auriculares',
  'control.hint.train': 'Entrenamiento', 'control.hint.keys': 'Modo de tecla',
  'control.hint.cwdec': 'Decodificación CW', 'control.hint.cwth': 'Umbral de decodificación',
  'control.hint.fmt': 'Formato de audio',
  'control.enum.frequencyA': 'Frecuencia A', 'control.enum.frequencyB': 'Frecuencia B',
  'control.enum.tuningStart': 'Iniciar sintonización', 'control.enum.spectrumWaterfall': 'Espectro + cascada',
  'control.enum.spectrumOnly': 'Solo espectro', 'control.enum.waterfallOnly': 'Solo cascada',
  'control.enum.dataAudio': 'Audio', 'control.enum.dataIq': 'IQ', 'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': 'Función en desarrollo', 'message.afFailed': 'No se pudo enviar el parámetro AF',
  'message.rfFailed': 'No se pudo enviar el parámetro RF', 'message.loginToChangeFrequency': 'Inicia sesión antes de cambiar la frecuencia',
  'message.frequencyFailed': 'No se pudo ajustar la frecuencia', 'message.frequencyError': 'Error al ajustar la frecuencia',
  'message.loginToChangeMode': 'Inicia sesión antes de cambiar el modo', 'message.modeFailed': 'No se pudo ajustar el modo',
  'message.modeError': 'Error al ajustar el modo', 'message.loginToModify': 'Inicia sesión antes de hacer cambios',
  'message.invalidFrequency': 'Introduce una frecuencia válida', 'message.invalidDeviceId': 'ID de dispositivo no válido',
  'message.removeFailed': 'No se pudo quitar el dispositivo de la sesión', 'message.removed': 'Dispositivo eliminado de la sesión',
  'message.removeRetry': 'No se pudo eliminar el dispositivo. Inténtalo más tarde.',
  'modal.power': 'Alimentación', 'modal.meter': 'Medidor', 'modal.switchMeter': 'Cambiar medidor (SWR/AUD/ALC)',
  'modal.powerOn': 'Encender', 'modal.powerOff': 'Apagar', 'modal.afMenu': 'Menú AF', 'modal.volume': 'Volumen',
  'modal.sendPowerOnMqtt': 'Enviar comando de encendido PMR171 (MQTT)',
  'modal.sendPowerOffMqtt': 'Enviar comando de apagado PMR171 (MQTT)',
  'modal.sliderHelp': 'Arrastra para ajustar el valor. Se enviará por MQTT al soltar.',
  'modal.loginForAf': 'Inicia sesión para ajustar AF.', 'modal.selectForAf': 'Selecciona un dispositivo para ajustar AF.',
  'modal.more': 'Más', 'modal.afMore': 'Aquí aparecerán más controles de AF.',
  'modal.rfMenu': 'Menú RF', 'modal.radioFrequency': 'RF',
  'modal.loginForRf': 'Inicia sesión para ajustar RF.', 'modal.selectForRf': 'Selecciona un dispositivo para ajustar RF.',
  'modal.rfMore': 'Aquí aparecerán más controles de RF.',
  'slider.speaker': 'Volumen del altavoz', 'slider.headphone': 'Volumen de auriculares', 'slider.mic': 'Ganancia MIC',
  'slider.compander': 'Relación del compansor', 'slider.bass': 'EQ de graves', 'slider.treble': 'EQ de agudos',
  'slider.rfGain': 'Ganancia RF (RFG)', 'slider.ifGain': 'Ganancia IF', 'slider.squelch': 'Silenciador (SQL)',
  'slider.preamp': 'Preamplificador (0=AMPA, 1=AMPB)',
  'mode.usb': 'Banda lateral superior', 'mode.lsb': 'Banda lateral inferior', 'mode.cwr': 'Recepción CW',
  'mode.cwl': 'Transmisión CW', 'mode.am': 'Modulación de amplitud', 'mode.wfm': 'FM de banda ancha',
  'mode.nfm': 'FM de banda estrecha', 'mode.digi': 'Modo digital', 'mode.pkt': 'Modo de paquetes',
  'button.power': 'Alimentación', 'button.morePending': 'Más (próximamente)',
};

const frFR: RadioRemoteMessages = {
  ...enUS,
  'common.unknown': 'Inconnu', 'common.close': 'Fermer', 'common.cancel': 'Annuler', 'common.send': 'Envoyer',
  'common.on': 'Activé', 'common.off': 'Désactivé', 'common.user': 'Utilisateur',
  'nav.overview': 'Vue des appareils', 'nav.voiceGroup': 'Relais réseau (groupe)', 'nav.serialDebug': 'Débogage série', 'nav.main': 'Navigation principale',
  'nav.gps': 'Coordonnées GPS', 'nav.currentDate': 'Date actuelle',
  'userMenu.label': 'Menu utilisateur', 'userMenu.profile': 'Profil', 'userMenu.switchMobile': 'Passer à la version mobile', 'userMenu.logout': 'Se déconnecter',
  'overview.onlineDevices': 'Appareils en ligne', 'overview.totalDevices': '{count} au total', 'overview.addDevice': 'Ajouter un appareil',
  'overview.loginRequired': 'Connectez-vous pour voir vos appareils', 'overview.loading': 'Chargement des appareils…',
  'overview.empty': 'Aucun appareil dans cette session. Cliquez pour en ajouter un.',
  'status.online': 'En ligne', 'status.inUse': 'En cours d’utilisation', 'status.offline': 'Hors ligne', 'status.unknown': 'Inconnu',
  'card.invalidDeviceId': 'ID d’appareil non valide', 'card.deleteDevice': 'Supprimer l’appareil',
  'card.deleteDeviceNamed': 'Supprimer l’appareil {name}', 'card.frequency': 'Fréquence',
  'card.frequencyDown': 'Réduire la fréquence de 1 kHz', 'card.frequencyMhz': 'Fréquence en MHz',
  'card.frequencyUp': 'Augmenter la fréquence de 1 kHz', 'card.pttTransmit': 'Émission PTT',
  'card.offlinePreview': 'Appareil hors ligne · Aperçu indisponible',
  'card.metersOffline': 'Indicateurs hors ligne · Aucune donnée', 'card.deleteTitle': 'Supprimer l’appareil',
  'card.delete': 'Supprimer', 'card.deleteConfirm': 'Retirer cet appareil de la session actuelle ?',
  'card.deviceName': 'Appareil : {name}', 'card.serialNumber': 'N° de série : {serial}',
  'gauge.po': 'Indicateur PO', 'gauge.signal': 'S-mètre', 'gauge.range': '0–34 crans',
  'detail.confirmFrequency': 'Confirmer la fréquence', 'detail.confirmMode': 'Confirmer le mode',
  'detail.selectSpectrumDevice': 'Sélectionnez un appareil pour afficher le spectre et la chute d’eau en direct',
  'detail.invalidDevice': 'Appareil non valide', 'detail.deviceOffline': 'Appareil hors ligne',
  'detail.loginForData': 'Connectez-vous pour récupérer les données',
  'detail.amplifierPreviewMissingId': 'Le snNumber de l’amplificateur est absent ; aperçu impossible',
  'control.title': 'Panneau de commande', 'control.scrollArea': 'Zone défilante des commandes radio',
  'control.commandSent': 'Commande {label} envoyée', 'control.commandFailed': 'Échec de l’envoi de la commande',
  'control.splitSent': 'Commande SPLIT envoyée', 'control.splitFailed': 'Échec de l’envoi de SPLIT',
  'control.comingSoon': 'Cette fonction est en cours de finalisation', 'control.selectDeviceFirst': 'Sélectionnez d’abord un appareil',
  'control.loginFirst': 'Connectez-vous d’abord', 'control.powerOnSent': 'Commande de mise sous tension envoyée',
  'control.powerOffSent': 'Commande d’arrêt envoyée', 'control.powerFailed': 'Échec de la commande d’alimentation',
  'control.parameterSent': 'Commande de paramètre envoyée', 'control.parameterFailed': 'Échec de l’envoi du paramètre',
  'control.toneSent': 'Commande de sous-ton envoyée', 'control.toneFailed': 'Échec de l’envoi du sous-ton',
  'control.toneTitle': 'TONE · Sous-ton',
  'control.txPowerHiLoTitle': 'L/H · Haute / basse',
  'control.factoryTitle': 'FACT · Paramètres usine',
  'control.factoryHint': 'Étalonner',
  'control.channelTitle': 'CHAN · Canaux',
  'control.channelHint': 'Canal',
  'control.filterBpf': 'Passe-bande',
  'control.filterLpf': 'Passe-bas',
  'control.filterWidth': 'Largeur',
  'control.factoryPasswordTitle': 'Mot de passe usine',
  'control.factoryPasswordHint': 'Saisissez le mot de passe usine.',
  'control.factoryPasswordWrong': 'Mot de passe incorrect',
  'control.factoryTabBand': 'Étalonnage bande',
  'control.factoryTabGlobal': 'Paramètres globaux',
  'control.factoryTabMode': 'Mode usine',
  'control.factoryRead': 'Lire',
  'control.factoryWrite': 'Écrire',
  'control.factoryReadBand': 'Lire cette bande',
  'control.factoryReadAll': 'Tout lire',
  'control.factoryReadGlobal': 'Lire globaux',
  'control.factoryModeOff': 'Arrêt',
  'control.factoryModeOn': 'Marche',
  'control.factoryModeSend': 'Envoyer',
  'control.factoryModeHint': 'Activez le mode usine avant d’écrire.',
  'control.factoryLastCommand': 'Dernier',
  'control.factoryReadCurrent': 'Tout lire',
  'control.factoryEngineering': 'Mode usine',
  'control.factoryBand': 'Bande',
  'control.factoryMode': 'Mode',
  'control.factoryPower': 'Puissance',
  'control.factoryUnread': 'Non lu',
  'control.factoryReadTimeout': 'Lecture expirée',
  'control.factoryWriteFailed': 'Échec d’écriture',
  'control.txPowerTitle': 'PWR · Puissance TX',
  'control.txPowerLow': 'Puissance basse',
  'control.txPowerHigh': 'Puissance haute',
  'control.txPowerLevel': 'Niveau de puissance',
  'control.txPowerHighShort': 'H',
  'control.txPowerLowShort': 'B',
  'control.txCtcss': 'Indice du sous-ton d’émission (0–51)',
  'control.rxCtcss': 'Indice du sous-ton de réception (0–51)', 'control.leadTone': 'Tonalité d’appel (0 / 1750 / 2135)',
  'control.devicePower': 'Alimentation de l’appareil', 'control.powerPrompt': 'Choisissez la commande d’alimentation à envoyer.',
  'control.sendPowerOn': 'Envoyer la commande de mise sous tension', 'control.sendPowerOff': 'Envoyer la commande d’arrêt',
  'control.hint.power': 'Alimentation', 'control.hint.rfg': 'Gain RF', 'control.hint.ifg': 'Gain FI',
  'control.hint.sql': 'Squelch', 'control.hint.agc': 'Gain automatique', 'control.hint.amp': 'Préamplificateur',
  'control.hint.svol': 'Haut-parleur', 'control.hint.hvol': 'Casque', 'control.hint.mic': 'Microphone',
  'control.hint.cmp': 'Compandeur vocal', 'control.hint.bas': 'Égaliseur graves', 'control.hint.trb': 'Égaliseur aigus',
  'control.hint.split': 'Fréquences séparées', 'control.hint.ab': 'Changer de fréquence', 'control.hint.nb': 'Suppresseur de parasites',
  'control.hint.nr': 'Réduction du bruit', 'control.hint.band': 'Bande', 'control.hint.nrl': 'Niveau de réduction du bruit',
  'control.hint.nbl': 'Niveau du suppresseur', 'control.hint.peak': 'Crête', 'control.hint.atu': 'Accord automatique',
  'control.hint.span': 'Étendue du spectre', 'control.hint.ref': 'Niveau de référence', 'control.hint.lohi': 'Puissance haute / basse', 'control.hint.pwr': 'Puissance d’émission', 'control.hint.fact': 'Paramètres usine',
  'control.hint.chan': 'Débogage des canaux',
  'control.hint.tone': 'Sous-ton', 'control.hint.speed': 'Vitesse de manipulation', 'control.hint.disp': 'Affichage',
  'control.hint.rit': 'Réglage fin de réception', 'control.hint.xit': 'Réglage fin d’émission',
  'control.hint.ltime': 'Durée d’appui long', 'control.hint.hplv': 'Niveau du casque',
  'control.hint.train': 'Entraînement', 'control.hint.keys': 'Mode de touche',
  'control.hint.cwdec': 'Décodage CW', 'control.hint.cwth': 'Seuil de décodage',
  'control.hint.fmt': 'Format audio',
  'control.enum.frequencyA': 'Fréquence A', 'control.enum.frequencyB': 'Fréquence B',
  'control.enum.tuningStart': 'Lancer l’accord', 'control.enum.spectrumWaterfall': 'Spectre + chute d’eau',
  'control.enum.spectrumOnly': 'Spectre uniquement', 'control.enum.waterfallOnly': 'Chute d’eau uniquement',
  'control.enum.dataAudio': 'Audio', 'control.enum.dataIq': 'IQ', 'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': 'Fonction en cours de développement', 'message.afFailed': 'Échec de l’envoi du paramètre AF',
  'message.rfFailed': 'Échec de l’envoi du paramètre RF', 'message.loginToChangeFrequency': 'Connectez-vous avant de modifier la fréquence',
  'message.frequencyFailed': 'Échec du réglage de la fréquence', 'message.frequencyError': 'Erreur lors du réglage de la fréquence',
  'message.loginToChangeMode': 'Connectez-vous avant de modifier le mode', 'message.modeFailed': 'Échec du réglage du mode',
  'message.modeError': 'Erreur lors du réglage du mode', 'message.loginToModify': 'Connectez-vous avant toute modification',
  'message.invalidFrequency': 'Saisissez une fréquence valide', 'message.invalidDeviceId': 'ID d’appareil non valide',
  'message.removeFailed': 'Échec du retrait de l’appareil', 'message.removed': 'Appareil retiré de la session',
  'message.removeRetry': 'Impossible de retirer l’appareil. Réessayez plus tard.',
  'modal.power': 'Alimentation', 'modal.meter': 'Indicateur', 'modal.switchMeter': 'Changer d’indicateur (SWR/AUD/ALC)',
  'modal.powerOn': 'Allumer', 'modal.powerOff': 'Éteindre', 'modal.afMenu': 'Menu AF', 'modal.volume': 'Volume',
  'modal.sendPowerOnMqtt': 'Envoyer la commande d’allumage PMR171 (MQTT)',
  'modal.sendPowerOffMqtt': 'Envoyer la commande d’arrêt PMR171 (MQTT)',
  'modal.sliderHelp': 'Faites glisser pour régler la valeur. Elle sera envoyée par MQTT au relâchement.',
  'modal.loginForAf': 'Connectez-vous pour régler l’AF.', 'modal.selectForAf': 'Sélectionnez un appareil pour régler l’AF.',
  'modal.more': 'Plus', 'modal.afMore': 'Les autres commandes AF apparaîtront ici.',
  'modal.rfMenu': 'Menu RF', 'modal.radioFrequency': 'RF',
  'modal.loginForRf': 'Connectez-vous pour régler le RF.', 'modal.selectForRf': 'Sélectionnez un appareil pour régler le RF.',
  'modal.rfMore': 'Les autres commandes RF apparaîtront ici.',
  'slider.speaker': 'Volume du haut-parleur', 'slider.headphone': 'Volume du casque', 'slider.mic': 'Gain MIC',
  'slider.compander': 'Rapport du compandeur', 'slider.bass': 'Égaliseur graves', 'slider.treble': 'Égaliseur aigus',
  'slider.rfGain': 'Gain RF (RFG)', 'slider.ifGain': 'Gain FI', 'slider.squelch': 'Squelch (SQL)',
  'slider.preamp': 'Préamplificateur (0=AMPA, 1=AMPB)',
  'mode.usb': 'Bande latérale supérieure', 'mode.lsb': 'Bande latérale inférieure', 'mode.cwr': 'Réception CW',
  'mode.cwl': 'Émission CW', 'mode.am': 'Modulation d’amplitude', 'mode.wfm': 'FM large bande',
  'mode.nfm': 'FM bande étroite', 'mode.digi': 'Mode numérique', 'mode.pkt': 'Mode paquet',
  'button.power': 'Alimentation', 'button.morePending': 'Plus (bientôt)',
};

const jaJP: RadioRemoteMessages = {
  ...enUS,
  'common.unknown': '不明', 'common.close': '閉じる', 'common.cancel': 'キャンセル', 'common.send': '送信',
  'common.on': 'オン', 'common.off': 'オフ', 'common.user': 'ユーザー',
  'nav.overview': 'デバイス概要', 'nav.voiceGroup': 'ネットワーク中継（グループ）', 'nav.serialDebug': 'シリアルデバッグ', 'nav.main': 'メインナビゲーション',
  'nav.gps': 'GPS 座標', 'nav.currentDate': '現在の日付',
  'userMenu.label': 'ユーザーメニュー', 'userMenu.profile': 'プロフィール', 'userMenu.switchMobile': 'モバイル版に切り替え', 'userMenu.logout': 'ログアウト',
  'overview.onlineDevices': 'オンラインデバイス', 'overview.totalDevices': '合計 {count} 台', 'overview.addDevice': 'デバイスを追加',
  'overview.loginRequired': 'デバイス一覧を表示するにはログインしてください', 'overview.loading': 'デバイスを読み込み中…',
  'overview.empty': 'セッションにデバイスがありません。クリックして追加してください。',
  'status.online': 'オンライン', 'status.inUse': '使用中', 'status.offline': 'オフライン', 'status.unknown': '不明',
  'card.invalidDeviceId': '無効なデバイス ID', 'card.deleteDevice': 'デバイスを削除',
  'card.deleteDeviceNamed': 'デバイス {name} を削除', 'card.frequency': '周波数',
  'card.frequencyDown': '周波数を 1 kHz 下げる', 'card.frequencyMhz': '周波数（MHz）',
  'card.frequencyUp': '周波数を 1 kHz 上げる', 'card.pttTransmit': 'PTT 送信',
  'card.offlinePreview': 'デバイスはオフライン · プレビュー不可',
  'card.metersOffline': 'メーターはオフライン · データなし', 'card.deleteTitle': 'デバイスを削除',
  'card.delete': '削除', 'card.deleteConfirm': 'このデバイスを現在のセッションから削除しますか？',
  'card.deviceName': 'デバイス：{name}', 'card.serialNumber': 'SN：{serial}',
  'gauge.po': 'PO メーター', 'gauge.signal': 'S メーター', 'gauge.range': '0～34 段階',
  'detail.confirmFrequency': '周波数を確定', 'detail.confirmMode': 'モードを確定',
  'detail.selectSpectrumDevice': 'リアルタイムのスペクトラムとウォーターフォールを表示するデバイスを選択してください',
  'detail.invalidDevice': '無効なデバイス', 'detail.deviceOffline': 'デバイスはオフライン',
  'detail.loginForData': 'データを取得するにはログインしてください',
  'detail.amplifierPreviewMissingId': 'アンプに snNumber がないため、プレビューできません',
  'control.title': 'コントロールパネル', 'control.scrollArea': '無線機コントロールパネルのスクロール領域',
  'control.commandSent': '{label} コマンドを送信しました', 'control.commandFailed': 'コマンドの送信に失敗しました',
  'control.splitSent': 'SPLIT コマンドを送信しました', 'control.splitFailed': 'SPLIT の送信に失敗しました',
  'control.comingSoon': 'この機能は現在整備中です', 'control.selectDeviceFirst': '先に概要画面でデバイスを選択してください',
  'control.loginFirst': '先にログインしてください', 'control.powerOnSent': '電源オンコマンドを送信しました',
  'control.powerOffSent': '電源オフコマンドを送信しました', 'control.powerFailed': '電源コマンドの送信に失敗しました',
  'control.parameterSent': 'パラメーターコマンドを送信しました', 'control.parameterFailed': 'パラメーターの送信に失敗しました',
  'control.toneSent': 'トーンコマンドを送信しました', 'control.toneFailed': 'トーンの送信に失敗しました',
  'control.toneTitle': 'TONE · サブトーン',
  'control.txPowerHiLoTitle': 'L/H · 高低出力',
  'control.factoryTitle': 'FACT · 工場パラメータ',
  'control.factoryHint': '校正',
  'control.channelTitle': 'CHAN · チャネルデバッグ',
  'control.channelHint': 'チャネル',
  'control.filterBpf': 'バンドパス',
  'control.filterLpf': 'ローパス',
  'control.filterWidth': '帯域幅',
  'control.factoryPasswordTitle': '工場パスワード',
  'control.factoryPasswordHint': '工場パスワードを入力してください。',
  'control.factoryPasswordWrong': 'パスワードが違います',
  'control.factoryTabBand': 'バンド校正',
  'control.factoryTabGlobal': '全体パラメータ',
  'control.factoryTabMode': '工場モード',
  'control.factoryRead': '読取',
  'control.factoryWrite': '書込',
  'control.factoryReadBand': 'このバンドを読取',
  'control.factoryReadAll': 'すべて読取',
  'control.factoryReadGlobal': '全体を読取',
  'control.factoryModeOff': 'オフ',
  'control.factoryModeOn': 'オン',
  'control.factoryModeSend': '送信',
  'control.factoryModeHint': '書き込み前に工場モードをオンにしてください。',
  'control.factoryLastCommand': '最近',
  'control.factoryReadCurrent': '一括読取',
  'control.factoryEngineering': '工場モード',
  'control.factoryBand': 'バンド',
  'control.factoryMode': 'モード',
  'control.factoryPower': '出力',
  'control.factoryUnread': '未読取',
  'control.factoryReadTimeout': '読取タイムアウト',
  'control.factoryWriteFailed': '書き込み失敗',
  'control.txPowerTitle': 'PWR · 送信出力',
  'control.txPowerLow': '低出力',
  'control.txPowerHigh': '高出力',
  'control.txPowerLevel': '出力レベル',
  'control.txPowerHighShort': '高',
  'control.txPowerLowShort': '低',
  'control.txCtcss': '送信サブトーン番号 (0–51)',
  'control.rxCtcss': '受信サブトーン番号 (0–51)', 'control.leadTone': 'リードトーン (0 / 1750 / 2135)',
  'control.devicePower': 'デバイス電源', 'control.powerPrompt': 'デバイスへ送信する電源コマンドを選択してください。',
  'control.sendPowerOn': '電源オンコマンドを送信', 'control.sendPowerOff': '電源オフコマンドを送信',
  'control.hint.power': '電源', 'control.hint.rfg': 'RF ゲイン', 'control.hint.ifg': 'IF ゲイン',
  'control.hint.sql': 'スケルチ', 'control.hint.agc': '自動ゲイン', 'control.hint.amp': 'プリアンプ',
  'control.hint.svol': 'スピーカー', 'control.hint.hvol': 'ヘッドホン', 'control.hint.mic': 'マイク',
  'control.hint.cmp': '音声コンパンダー', 'control.hint.bas': '低音 EQ', 'control.hint.trb': '高音 EQ',
  'control.hint.split': 'スプリット周波数', 'control.hint.ab': '周波数切り替え', 'control.hint.nb': 'ノイズブランカー',
  'control.hint.nr': 'ノイズリダクション', 'control.hint.band': 'バンド', 'control.hint.nrl': 'ノイズリダクションレベル',
  'control.hint.nbl': 'ノイズブランカーレベル', 'control.hint.peak': 'ピーク', 'control.hint.atu': '自動チューニング',
  'control.hint.span': 'スペクトラム範囲', 'control.hint.ref': '基準レベル', 'control.hint.lohi': '高低出力', 'control.hint.pwr': '送信出力', 'control.hint.fact': '工場パラメータ',
  'control.hint.chan': 'チャネルデバッグ',
  'control.hint.tone': 'サブトーン', 'control.hint.speed': 'キー速度', 'control.hint.disp': '表示',
  'control.hint.rit': '受信微調整', 'control.hint.xit': '送信微調整', 'control.hint.ltime': '長押し時間',
  'control.hint.hplv': 'ヘッドホンレベル', 'control.hint.train': 'トレーニング', 'control.hint.keys': 'キーモード',
  'control.hint.cwdec': 'CW デコード', 'control.hint.cwth': 'デコードしきい値',
  'control.hint.fmt': '音声形式',
  'control.enum.frequencyA': '周波数 A', 'control.enum.frequencyB': '周波数 B',
  'control.enum.tuningStart': 'チューニング開始', 'control.enum.spectrumWaterfall': 'スペクトラム + ウォーターフォール',
  'control.enum.spectrumOnly': 'スペクトラムのみ', 'control.enum.waterfallOnly': 'ウォーターフォールのみ',
  'control.enum.dataAudio': '音声', 'control.enum.dataIq': 'IQ', 'control.enum.dataOpus': 'Opus',
  'message.featureDeveloping': '機能を開発中です', 'message.afFailed': 'AF パラメーターの送信に失敗しました',
  'message.rfFailed': 'RF パラメーターの送信に失敗しました', 'message.loginToChangeFrequency': '周波数を変更するにはログインしてください',
  'message.frequencyFailed': '周波数の設定に失敗しました', 'message.frequencyError': '周波数の設定中にエラーが発生しました',
  'message.loginToChangeMode': 'モードを変更するにはログインしてください', 'message.modeFailed': 'モードの設定に失敗しました',
  'message.modeError': 'モードの設定中にエラーが発生しました', 'message.loginToModify': '変更するにはログインしてください',
  'message.invalidFrequency': '有効な周波数を入力してください', 'message.invalidDeviceId': '無効なデバイス ID',
  'message.removeFailed': 'セッションからデバイスを削除できませんでした', 'message.removed': 'セッションからデバイスを削除しました',
  'message.removeRetry': 'デバイスを削除できませんでした。後でもう一度お試しください。',
  'modal.power': '電源', 'modal.meter': 'メーター', 'modal.switchMeter': 'メーターを切り替え（SWR/AUD/ALC）',
  'modal.powerOn': '電源オン', 'modal.powerOff': '電源オフ', 'modal.afMenu': 'AF メニュー', 'modal.volume': '音量',
  'modal.sendPowerOnMqtt': 'PMR171 電源オンコマンドを送信（MQTT）',
  'modal.sendPowerOffMqtt': 'PMR171 電源オフコマンドを送信（MQTT）',
  'modal.sliderHelp': 'ドラッグして値を調整します。指を離すと MQTT で送信されます。',
  'modal.loginForAf': 'AF を調整するにはログインしてください。', 'modal.selectForAf': 'AF を調整するデバイスを選択してください。',
  'modal.more': 'その他', 'modal.afMore': '追加の AF 項目はここに表示されます。',
  'modal.rfMenu': 'RF メニュー', 'modal.radioFrequency': 'RF',
  'modal.loginForRf': 'RF を調整するにはログインしてください。', 'modal.selectForRf': 'RF を調整するデバイスを選択してください。',
  'modal.rfMore': '追加の RF 項目はここに表示されます。',
  'slider.speaker': 'スピーカー音量', 'slider.headphone': 'ヘッドホン音量', 'slider.mic': 'MIC ゲイン',
  'slider.compander': '音声コンパンダー比', 'slider.bass': '低音 EQ', 'slider.treble': '高音 EQ',
  'slider.rfGain': 'RF ゲイン（RFG）', 'slider.ifGain': 'IF ゲイン', 'slider.squelch': 'スケルチ（SQL）',
  'slider.preamp': 'プリアンプ（0=AMPA、1=AMPB）',
  'mode.usb': '上側波帯', 'mode.lsb': '下側波帯', 'mode.cwr': 'CW 受信',
  'mode.cwl': 'CW 送信', 'mode.am': '振幅変調', 'mode.wfm': '広帯域 FM',
  'mode.nfm': '狭帯域 FM', 'mode.digi': 'デジタルモード', 'mode.pkt': 'パケットモード',
  'button.power': '電源', 'button.morePending': 'その他（準備中）',
};

export const radioRemoteLocales: LocaleModule<RadioRemoteMessages> = {
  zh_CN: zhCN,
  zh_HK: zhHK,
  en_US: enUS,
  ru_RU: ruRU,
  es_ES: esES,
  fr_FR: frFR,
  ja_JP: jaJP,
};

export type RadioRemoteLocaleKey = keyof RadioRemoteMessages;
